<template>
  <v-breadcrumbs :items="items" class="breadcrumbs px-4 elevation-3">
    <template v-slot:item="props">
      <v-breadcrumbs-item v-if="props.item.disabled" disabled>
        {{ props.item.text.toUpperCase() }}
      </v-breadcrumbs-item>
      <v-breadcrumbs-item v-else :to="props.item.href" :exact="true">
        {{ props.item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: "Breadcrumb",
  data: () => ({
    items: []
  }),
  watch: {
    $route() {
      this.updateList();
    }
  },
  mounted() {
    this.updateList();
  },
  methods: {
    updateList() {
      this.items = this.$route.meta.breadcrumb;
    }
  }
};
</script>
